// extracted by mini-css-extract-plugin
export default {"NavGroup":"NavGroup_NavGroup__joUCx","Label":"NavGroup_Label__tK9Ta","Caret":"NavGroup_Caret__SM+aT","isCollapsed":"NavGroup_isCollapsed__KP1rV"};